import Media from "@PegasusCore/pegasus-one-media/src/script.js";

class ExtendedMedia extends Media {
  init() {
    super.init();
  }
}

document.addEventListener("alpine:init", () => {
  Alpine.data("PegasusMediaBlock", () => new ExtendedMedia());

  Alpine.data("videoThumbnailModal", () => ({
    open: false,
    isLoaded: false,

    openModal() {
      this.open = true;
      document.body.classList.add("modal-open");
      this.$nextTick(() => {
        this.$dispatch("modalopen");
        setTimeout(() => {
          this.isLoaded = true;
        }, 100);
      });
    },

    handleModalClose() {
      document.body.classList.remove("modal-open");
      this.open = false;
      this.isLoaded = false;

      const iframe = this.$root.querySelector("iframe");
  
      if (iframe) {
          if (!iframe.hasAttribute("data-src")) {
              iframe.setAttribute("data-src", iframe.getAttribute("src"));
          }
  
          const originalSrc = iframe.getAttribute("data-src");
          iframe.setAttribute("src", "about:blank");
  
          setTimeout(() => {
              iframe.setAttribute("src", originalSrc);
          }, 100);
      } else {
          console.log("No iframe video found.");
      }
    }
  }));
});
